// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Du9O","toggleWrap":"styles_toggleWrap__B29oq","content":"styles_content__2bcWG","selectAreaCode":"styles_selectAreaCode__3Igfk"};